import WpuDetail from "./WpuDetail"

export default WpuDetail;



// WEBPACK FOOTER //
// ./src/components/atomic/pages/WpuDetail/index.js